module.exports = __webpack_public_path__ + "img/__icon_INNA_CYSTERNA.f5f419b4.svg";